'use client';

import animationData from '@/animations/feature-shared-inbox.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationFeatureSharedInboxProps {
  playing?: boolean;
}

const AnimationFeatureSharedInbox: FC<AnimationFeatureSharedInboxProps> = ({ playing }) => {
  return (
    <div className="aspect-[396/348]">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationFeatureSharedInbox;
